module.exports = __webpack_public_path__ + "img/background_loging.5556c85a.png";